var map = {
	"./01_tag_free-wifi.svg": 514,
	"./02_tag_free-parking.svg": 515,
	"./03_tag_paid-parking.svg": 516,
	"./04_tag_indoor-pool.svg": 517,
	"./05_tag_outdoor-pool-in-summer.svg": 518,
	"./06_tag_beach.svg": 519,
	"./07_tag_large-public-bath.svg": 520,
	"./08_tag_hot-spring.svg": 521,
	"./09_tag_spa.svg": 522,
	"./10_tag_outdoor-bath.svg": 523,
	"./11_tag_non-smoking.svg": 524,
	"./12_tag_convenience-store.svg": 525,
	"./13_tag_restaurant.svg": 526,
	"./14_tag_connecting-room.svg": 527,
	"./15_tag_with-kitchen.svg": 528,
	"./16_tag_kitchen.svg": 529,
	"./17_tag_fitness-gym.svg": 530,
	"./18_tag_paid-massage-service.svg": 531,
	"./19_tag_paid-beauty-salon.svg": 532,
	"./20_tag_vending-machine.svg": 533,
	"./21_tag_kitchenware-tableware.svg": 534,
	"./22_tag_washing-machine.svg": 535,
	"./23_tag_clothes-dryer.svg": 536,
	"./24_tag_paid-coin-laundry.svg": 537,
	"./25_tag_courtesy-bus.svg": 538,
	"./26_tag_lounge.svg": 539,
	"./27_tag_bbq-garden.svg": 540,
	"./28_tag_induction-cooker.svg": 154,
	"./29__tag_microwave.svg": 281,
	"./30_tag_smoking-area.svg": 541,
	"./31_tag_pet-friendly.svg": 542,
	"./tag_convenience-store.svg": 543,
	"./tag_free-parking.svg": 544,
	"./tag_free-wifi.svg": 545,
	"./tag_outdoor-pool-in-summer.svg": 546,
	"./tag_paid-coin-laundry.svg": 547,
	"./tag_restaurant.svg": 548,
	"./tag_vending-machine.svg": 549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;